import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../Component/Sidebar/Sidebar";
import Header from "../Component/Header/Header";
import { useSidebar } from "../Context/SidebarContext";

function Layout() {
  const { open } = useSidebar();
  const location = useLocation();

  const fullScreenPages = ["/home-page"];
  const isFullScreen = fullScreenPages.includes(location.pathname);

  return (
    <div className="min-h-screen bg-gray-50" dir="rtl">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <main
        className={`
          min-h-screen
          transition-all duration-300 ease-in-out
          ${open
            ? "mr-[240px] pr-4"
            : "mr-[80px] pr-3"
          }
        `}
      >
        {/* Header */}
        {!isFullScreen && (
          <div className="pt-3 pl-4">
            <Header />
          </div>
        )}

        {/* Page Content */}
        <div
          className={`
            ${isFullScreen
              ? "w-full"
              : "px-4 py-4"
            }
          `}
        >
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default Layout;